module.exports = __webpack_public_path__ + "img/app-provisioning.e4fdf369.svg";